import { Check } from "@styled-icons/fa-solid/Check";

import { Box } from "rebass";

export function EnqueteStatusValidIcon() {
  return (
    <Box
      sx={{
        color: "#94AC51",
        width: "18px",
      }}
    >
      <Check />
    </Box>
  );
}
